import React, { Component } from "react";
import './../../App.css';
import { Card } from "react-bootstrap";
import { Form } from 'react-bootstrap';
import { displayAlertMessage } from './../../constants/alertMessage.jsx';
import authHeader from "../../services/auth-header";


class FormEditImageBanniere extends Component {

    constructor(props) {
        super(props);
        this.state = {
            linkImage: this.props.img.linkImage,
            position: this.props.img.position,
            image: ""
        }

        this.updateInput = this.updateInput.bind(this);
        this.updateImage = this.updateImage.bind(this);
        this.updatePosition = this.updatePosition.bind(this);
        this.handleEdit = this.handleEdit.bind(this);
    }

    /* clearMessage() {
        document.getElementById('alertMessage').innerHTML("");
    } */

    updateImage(event) {
        console.log(event.target.file)
        this.setState({ image: event.target.value })
        console.log(this.state.image)
    }

    updateInput(event) {
        this.setState({ linkImage: event.target.value })
    }

    updatePosition(event) {
        this.setState({ position: event.target.value })
    }

    handleEdit() {
        const formData = new FormData();
        formData.append('id', this.props.img.id);
        formData.append('position', this.state.position);
        formData.append('linkImage', this.state.linkImage);

        const fileInput = document.getElementById('formFile');

        const options = {
            mode: 'no-cors',
            method: 'POST',
            body: formData
        };



        //if (this.state.image !== null) {
        //  console.log('file', this.state.image.files[0]);
        //}
        //else {
        //formData.append('file', this.state.image.files[0]);
        //}

        fetch('/lineup/api/image/edit/editImage/', {
            mode: 'cors',
            method: "POST",
            headers: authHeader(),
            body: formData
        }).then(function (res) {
            if (res.ok) {
                console.log("L'image a bien été modifiée");
                // location.reload();
                displayAlertMessage("alert alert-success", "L'image a bien été modifiée")
            } else if (res.status == 401) {
                displayAlertMessage("alert alert-danger", "Erreur lors de la modification de l'image")
            }
        }, function (e) {
            console.log("Error ");
            console.log(e);
        });

        /*
                fetch('/api/image/editImage', options)
                    .then(response => {
                        response.json().then((e) => {
                            console.log(e)
                            //displayAlertMessage("alert alert-success", "L'image a bien été modifiée")
                        })
                    }).catch(err => {
                        //  displayAlertMessage("alert alert-danger", "Erreur lors de la modification de l'image")
                        console.log("Impossible d'accéder à l'api");
                        console.log(err)
                    })
                //}
                */
    }

    handleDelete() {
        const formData = new FormData();
        formData.append('id', this.props.img.id);

        fetch('/lineup/api/image/edit/deleteImage/', {
            mode: 'cors',
            headers: authHeader(),
            method: "POST",
            body: formData
        }).then(function (res) {
            if (res.ok) {
                console.log("L'image a bien été supprimée");
                location.reload();
                displayAlertMessage("alert alert-success", "L'image a bien été supprimée")
            } else if (res.status == 401) {
                displayAlertMessage("alert alert-danger", "Erreur lors de la suppression de l'image")
            }
        }, function (e) {
            console.log("Error ");
            console.log(e);
        });
    }

    handlePublish() {
        const formData = new FormData();
        formData.append('id', this.props.img.id);

        fetch('/lineup/api/image/edit/publishImage/', {
            mode: 'cors',
            method: "POST",
            headers: authHeader(),
            body: formData
        }).then(function (res) {
            if (res.ok) {
                console.log("L'image a bien été publiée");
                location.reload();
                displayAlertMessage("alert alert-success", "L'image a bien été publiée")
            } else if (res.status == 401) {
                displayAlertMessage("alert alert-danger", "Erreur lors de la publication de l'image")
            }
        }, function (e) {
            console.log("Error ");
            console.log(e);
        });
    }

    render() {
        return (
            <form>
                <Card key={this.props.index} border="secondary">
                    <Card.Body>
                        <Card.Title>
                            <div className="cle">
                                <img 
                                 src={`data:image/jpeg;base64,${this.props.img.imageEncoded}`}></img>
                            </div>
                        </Card.Title>
                        <Card.Text>
                            <Form.Group controlId="formFile" className="mb-3">
                                {/* <Form.Label>Veuillez choisir une autre image</Form.Label>
                                <Form.Control type="file" onChange={(evt) => { this.updateImage(evt) }}></Form.Control> */}

                                {/* </Form.Group>

                            <Form.Group className="mb-3"> */}

                                <Form.Label>Veuillez choisir la position de l'image lors de l'affichage de la bannière</Form.Label>
                                <Form.Select id="positionImage" className="rounded-0 shadow" defaultValue={this.props.img.position}
                                    onChange={(evt) => { this.updatePosition(evt) }}>
                                    <option value="1">1</option>
                                    <option value="2">2</option>
                                    <option value="3">3</option>
                                </Form.Select >
                            </Form.Group>
                            <br />

                            <label>Lien de l'image (le lien doit commencer par (http://)</label>
                            <textarea className="form-control" type="text" defaultValue={this.props.img.linkImage}
                                onChange={(evt) => { this.updateInput(evt) }}></textarea>


                            <br></br>
                            <div className="row">
                                <div className="col">
                                    <button type="button" hidden={this.props.img.afficher} className="btn btn-outline-success" onClick={() => { this.handlePublish() }}>Publier</button>
                                </div>

                                <div className="col">
                                    <button type="button" className="btn btn-outline-info" onClick={() => { this.handleEdit() }}>Modifier</button>
                                </div>

                                <div className="col">
                                    <button type="button" className="btn btn-outline-danger" onClick={() => { this.handleDelete() }}>Supprimer</button>
                                </div>
                            </div>
                        </Card.Text>
                    </Card.Body>
                </Card>
            </form>
        );
    }
}
export default FormEditImageBanniere;
